import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector, RootState, useAppDispatch } from '@Store/store';
import { hasAuthToken } from '@Utils/checks';
import Loader from '@Components/Loader';
import { ROUTES } from '@Constants/routes';
import { AnalyticsParamBuilder } from '@Utils/common';
import posthog from 'posthog-js';

const COMPONENT = "protected_route";

export const ProtectedRoute: React.FC<any> = ({ Component, props }) => {
  const { user, isUserfetched } = useAppSelector((state: RootState) => state.profile);
  const selectedIgId = useAppSelector((state: RootState) => state.igSelection.selectedIgId);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if ((!user?.email && isUserfetched) || !hasAuthToken()) {
      posthog.capture("ui_action", AnalyticsParamBuilder({
        kingdom: COMPONENT,
        phylum: "redirect",
        classValue: ROUTES.LOGIN,
        genus: "auto",
        family: "token_issue",
      }));
      navigate(ROUTES.LOGIN, { replace: true });
    } else if (user?.ig_ids.length == 0) {
      posthog.capture("ui_action", AnalyticsParamBuilder({
        kingdom: COMPONENT,
        phylum: "redirect",
        classValue: ROUTES.IG_CONNECT,
        genus: "auto",
        family: "no_ig_connected",
      }));
      navigate(ROUTES.IG_CONNECT);
    } else if (!selectedIgId && user?.ig_ids.length >= 1) {
      // Redirect to accounts selection page if no IG is selected
      const isOnAccounts = location.pathname === ROUTES.IG_SELECT;
      const isOnConnect = location.pathname === ROUTES.IG_CONNECT || location.pathname === ROUTES.IG_CONNECT_SUCCESS;
      if (!isOnAccounts && !isOnConnect) {
        posthog.capture("ui_action", AnalyticsParamBuilder({
          kingdom: COMPONENT,
          phylum: "redirect",
          classValue: ROUTES.IG_SELECT,
          genus: "auto",
          family: "no_ig_selected",
        }));
        navigate(ROUTES.IG_SELECT, { state: { from: location.pathname }, replace: true });
      }
    }
  }, [user, isUserfetched, selectedIgId, location.pathname]);

  return <>{isUserfetched ? <Component {...props} /> : <Loader isLoading={true} />}</>;
};
